import useAppMutation from 'hooks/useAppMutation';
import useNotify from 'hooks/useNotify';
import { GuestReviewTemplatePayload } from 'models/automation/Reviews';
import API from 'services/API';
import { useTranslation } from 'react-i18next';

export const ADD_GUEST_REVIEW_TEMPLATE_MUTATION_KEY =
  'add-guest-review-template';

export const UPDATE_GUEST_REVIEW_TEMPLATE_MUTATION_KEY =
  'update-guest-review-template';

export const DELETE_GUEST_REVIEW_TEMPLATE_MUTATION_KEY =
  'delete-guest-review-template';

const useGuestReviewTemplateMutations = () => {
  const { notifyError } = useNotify();
  const { t } = useTranslation();

  const { mutateAsync: addReviewTemplate } = useAppMutation(
    [ADD_GUEST_REVIEW_TEMPLATE_MUTATION_KEY],
    ({
      payload,
    }: {
      payload: Omit<GuestReviewTemplatePayload, 'agencyUid'>;
    }) => {
      return API.post('/api/internal/predefined-hosts-reviews', {
        ...payload,
      });
    },
    {
      onError: () => {
        notifyError(
          t('pageAutomations.reviews.guestReviewTemplates.error.add'),
        );
      },
    },
  );

  const { mutateAsync: updateReviewTemplate } = useAppMutation(
    [UPDATE_GUEST_REVIEW_TEMPLATE_MUTATION_KEY],
    ({
      payload,
      uid,
    }: {
      payload: GuestReviewTemplatePayload;
      uid: string;
    }) => {
      return API.put(`/api/internal/predefined-hosts-reviews/${uid}`, {
        ...payload,
      });
    },
    {
      onError: () => {
        notifyError(
          t('pageAutomations.reviews.guestReviewTemplates.error.update'),
        );
      },
    },
  );

  const { mutateAsync: deleteReviewTemplate } = useAppMutation(
    [DELETE_GUEST_REVIEW_TEMPLATE_MUTATION_KEY],
    ({ uid }: { uid: string }) => {
      return API.delete(`/api/internal/predefined-hosts-reviews/${uid}`);
    },
  );

  return {
    addReviewTemplate,
    updateReviewTemplate,
    deleteReviewTemplate,
  };
};

export default useGuestReviewTemplateMutations;
